import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: function () {
      return import('../views/LoginView.vue')
    },
    meta: { title: '登录' }
  },
  {
    path: "/admin",
    name: "admin",
    meta: { title: "首页", requiresAuth: true },
    redirect: "/admin",
    component: Layout,
    children:[
      {
        path: '/stores',
        name: '/stores',
        component: function () {
          return import('../views/store/ListView.vue')
        },
        meta: { title: '门店列表' }
      },
      {
        path: '/store_delivery',
        name: '/store_delivery',
        component: function () {
          return import('../views/store/store_delivery.vue')
        },
        meta: { title: '门店配送方式' }
      },
      {
        path: '/insert_stores',
        name: 'insert_stores',
        component: function () {
          return import('../views/store/InsertView.vue')
        },
        meta: { title: '新增门店' }
      },
      {
        path: '/users',
        name: 'users',
        component: function () {
          return import('../views/set/AccountManagement.vue')
        },
        meta: { title: '账号管理' }
      },
      {
        path: '/data_set',
        name: 'data_set',
        component: function () {
          return import('../views/set/data_set.vue')
        },
        meta: { title: '展示账号管理' }
      },
      {
        path: '/insert_users',
        name: 'insert_users',
        component: function () {
          return import('../views/set/InsertAccount.vue')
        }
      },
      {
        path: '/logs',
        name: 'logs',
        component: function () {
          return import('../views/set/OperationLog.vue')
        },
        meta: { title: '操作日志' }
      },
      {
        path: '/roles',
        name: 'roles',
        component: function () {
          return import('../views/set/RolesView.vue')
        },
        meta: { title: '角色管理' }
      },
      {
        path: '/mobile_roles',
        name: 'mobile_roles',
        component: function () {
          return import('../views/set/mobileRoles.vue')
        },
        meta: { title: 'APP角色管理' }
      },
      {
        path: '/insert_mobile_roles',
        name: 'insert_mobile_roles',
        component: function () {
          return import('../views/set/InsertMobileRoles.vue')
        },
        meta: { title: '新增APP角色' }
      },
      {
        path: '/merchant',
        name: 'merchant',
        component: function () {
          return import('../views/merchant/IndexView.vue')
        },
        meta: { title: '商户信息' }
      },
      {
        path: '/store_detail',
        name: 'store_detail',
        component: function () {
          return import('../views/store/DetailView.vue')
        }
      },
      {
        path: '/regions',
        name: '/regions',
        component: function () {
          return import('../views/store/region/RegionList.vue')
        },
        meta: { title: '门店区域' }
      },
      {
        path: '/open_merchant',
        name: 'open_merchant',
        component: function () {
          return import('../views/merchant/OpenPayment.vue')
        },
        meta: { title: '开通收款账户' }
      },
      {
        path: '/insert_roles',
        name: 'insert_roles',
        component: function () {
          return import('../views/set/InsertRoles.vue')
        },
        meta: { title: '新增角色' }
      },
      {
        path: '/exports',
        name: 'exports',
        component: function () {
          return import('../views/set/ExportsView.vue')
        },
        meta: { title: '导出记录' }
      },
      {
        path: '/audit_explosive_product',
        name: 'audit_explosive_product',
        component: function () {
          return import('../views/goods/examine/auditexplosiveProduct.vue')
        },
        meta: { title: '爆品审核' }
      },
      {
        path: '/audit_product',
        name: 'audit_product',
        component: function () {
          return import('../views/goods/examine/auditProduct.vue')
        },
        meta: { title: '商品审核' }
      },
      {
        path: '/categorys',
        name: 'categorys',
        component: function () {
          return import('../views/goods/manage/categorysView.vue')
        },
        meta: { title: '商品分类' }
      },
      {
        path: '/products',
        name: 'products',
        component: function () {
          return import('../views/goods/manage/productsView.vue')
        },
        meta: { title: '商品列表',keepAlive: true }
      },
      {
        path: '/hospital_err_product',
        name: 'hospital_err_product',
        component: function () {
          return import('../views/goods/manage/hospital_err_product.vue')
        },
        meta: { title: '异常商品'}
      },
      {
        path: '/products_store',
        name: 'products_store',
        component: function () {
          return import('../views/goods/manage/aStoreView.vue')
        },
        meta: { title: '分配门店' }
      },
      {
        path: '/insert_products',
        name: 'insert_products',
        component: function () {
          return import('../views/goods/manage/InsertProducts.vue')
        },
        meta: { title: '新增商品'}
      },
      {
        path: '/allocation_products',
        name: 'allocation_products',
        component: function () {
          return import('../views/goods/manage/allocationView.vue')
        },
        meta: { title: '一键分配门店商品' }
      },
      {
        path: '/combination_products',
        name: 'combination_products',
        component: function () {
          return import('../views/goods/manage/combinationView.vue')
        },
        meta: { title: '组合商品'}
      },
      {
        path: '/examine_products',
        name: 'examine_products',
        component: function () {
          return import('../views/goods/manage/examineView.vue')
        },
        meta: { title: '审核列表' }
      },
      {
        path: '/explosive_cate',
        name: 'explosive_cate',
        component: function () {
          return import('../views/goods/explosive/cateView.vue')
        },
        meta: { title: '海斛商品分类' }
      },
      {
        path: '/explosive_local',
        name: 'explosive_local',
        component: function () {
          return import('../views/goods/explosive/explosiveLocal.vue')
        },
        meta: { title: '本地海斛商品',keepAlive: true }
      },
      {
        path: '/explosive_local_insert',
        name: 'explosive_local_insert',
        component: function () {
          return import('../views/goods/explosive/insertView.vue')
        },
        meta: { title: '新增海斛商品',keepAlive: true }
      },
      {
        path: '/points_product_insert',
        name: 'points_product_insert',
        component: function () {
          return import('../views/goods/points/insertView.vue')
        },
        meta: { title: '新增海金商品',keepAlive: true }
      },
      {
        path: '/explosive_remote',
        name: 'explosive_remote',
        component: function () {
          return import('../views/goods/explosive/explosiveRemote.vue')
        },
        meta: { title: '云仓爆品' }
      },
      {
        path: '/product_setting',
        name: 'product_setting',
        component: function () {
          return import('../views/goods/set/productSetting.vue')
        },
        meta: { title: '底部详情' }
      },
      {
        path: '/product_setting_insert',
        name: 'product_setting_insert',
        component: function () {
          return import('../views/goods/set/insertView.vue')
        },
        meta: { title: '新增模板' }
      },
      {
        path: '/banner',
        name: 'banner',
        component: function () {
          return import('../views/operation/banner/bannerView.vue')
        },
        meta: { title: 'banner管理' }
      },
      {
        path: '/show_config',
        name: 'show_config',
        component: function () {
          return import('../views/transactionSettings/mall/merchant_show_config.vue')
        },
        meta: { title: '商城显示配置' }
      },
      {
        path: '/trans_config',
        name: 'trans_config',
        component: function () {
          return import('../views/transactionSettings/mall/merchant_trans_config.vue')
        },
        meta: { title: '商城交易配置' }
      },{
        path: '/exp_recharge_config',
        name: 'exp_recharge_config',
        component: function () {
          return import('../views/transactionSettings/shoppingGold/merchant_exp_recharge_config.vue')
        },
        meta: { title: '充值设置' }
      },
      {
        path: '/order_reason_config',
        name: 'order_reason_config',
        component: function () {
          return import('../views/transactionSettings/afterSales/merchant_order_reason_config.vue')
        },
        meta: { title: '取消原因设置' }
      },
      {
        path: '/sale_after_config',
        name: 'sale_after_config',
        component: function () {
          return import('../views/transactionSettings/afterSales/merchant_sale_after_config.vue')
        },
        meta: { title: '订单售后设置' }
      },
      {
        path: '/order_exp_config',
        name: 'order_exp_config',
        component: function () {
          return import('../views/transactionSettings/timeout/merchant_order_exp_config.vue')
        },
        meta: { title: '超时设置' }
      },
      {
        path: '/card_refund_config',
        name: 'card_refund_config',
        component: function () {
          return import('../views/transactionSettings/membership/merchant_card_refund_config.vue')
        },
        meta: { title: '会员卡设置' }
      },
      {
        path: '/kf_qw_config',
        name: 'kf_qw_config',
        component: function () {
          return import('../views/operation/customer/merchant_kf_qw_config.vue')
        },
        meta: { title: '客服管理' }
      },
      {
        path: '/activity_rule',
        name: 'activity_rule',
        component: function () {
          return import('../views/operation/set/rule.vue')
        },
        meta: { title: '活动规则' }
      },
      {
        path: '/user_protocol',
        name: 'user_protocol',
        component: function () {
          return import('../views/operation/set/protocol.vue')
        },
        meta: { title: '用户协议' }
      },{
        path: '/user_report',
        name: 'user_report',
        component: function () {
          return import('../views/operation/manage/sugesstion.vue')
        },
        meta: { title: '意见反馈' }
      },
      {
        path: '/about_us',
        name: 'about_us',
        component: function () {
          return import('../views/operation/set/text.vue')
        },
        meta: { title: '关于我们' }
      },
      {
        path: '/insert_banner',
        name: 'insert_banner',
        component: function () {
          return import('../views/operation/banner/insertView.vue')
        },
        meta: { title: '新增banner' }
      },
      {
        path: '/insert_floor',
        name: 'insert_floor',
        component: function () {
          return import('../views/operation/banner/insertFloor.vue')
        },
        meta: { title: '新增banner' }
      },
      {
        path: '/district',
        name: 'district',
        component: function () {
          return import('../views/operation/banner/districtView.vue')
        },
        meta: { title: '金刚区管理' }
      },
      {
        path: '/floor',
        name: 'floor',
        component: function () {
          return import('../views/operation/banner/floorView.vue')
        },
        meta: { title: '楼层管理' }
      },
      {
        path: '/banner_pop',
        name: 'banner_pop',
        component: function () {
          return import('../views/operation/banner/promptView.vue')
        },
        meta: { title: '弹窗管理' }
      },
      {
        path: '/ad',
        name: 'ad',
        component: function () {
          return import('../views/operation/banner/ad.vue')
        },
        meta: { title: '个人中心广告' }
      },
      {
        path: '/insert_prompt',
        name: 'insert_prompt',
        component: function () {
          return import('../views/operation/banner/insertPrompt.vue')
        },
        meta: { title: '新增弹窗'}
      },
      {
        path: '/member',
        name: 'member',
        component: function () {
          return import('../views/member/manage/listView.vue')
        },
        meta: { title: '会员列表' }
      },
      {
        path: '/member_exchange',
        name: 'member_exchange',
        component: function () {
          return import('../views/member/manage/member_exchange.vue')
        },
        meta: { title: '更换手机号' }
      },
      {
        path: '/member_detail',
        name: 'member_detail',
        component: function () {
          return import('../views/member/manage/detailView.vue')
        },
        meta: { title: '会员详情' }
      },
      {
        path: '/vip_member',
        name: 'vip_member',
        component: function () {
          return import('../views/member/manage/vipMember.vue')
        },
        meta: { title: 'VIP会员列表' }
      },
      {
        path: '/member_store_group',
        name: 'member_store_group',
        component: function () {
          return import('../views/member/set/memberStoreGroup.vue')
        },
        meta: { title: '门店分组' }
      },
      {
        path: '/member_level',
        name: 'member_level',
        component: function () {
          return import('../views/member/set/memberLevel.vue')
        },
        meta: { title: '会员类型' }
      },
      {
        path: '/member_notice',
        name: 'member_notice',
        component: function () {
          return import('../views/member/set/memberNotice.vue')
        },
        meta: { title: '提醒设置' }
      },
      {
        path: '/member_card_up',
        name: 'member_card_up',
        component: function () {
          return import('../views/member/set/member_card_up.vue')
        },
        meta: { title: '会员升级设置' }
      },
      {
        path: '/rights_list',
        name: 'rights_list',
        component: function () {
          return import('../views/member/set/memberRight.vue')
        },
        meta: { title: '权益列表' }
      },
      {
        path: '/member_level_set',
        name: 'member_level_set',
        component: function () {
          return import('../views/member/set/cardRight.vue')
        },
        meta: { title: '设置权益' }
      },
      {
        path: '/member_insert_right',
        name: 'member_insert_right',
        component: function () {
          return import('../views/member/set/insertRight.vue')
        },
        meta: { title: '新增权益' }
      },
      {
        path: '/promotion',
        name: 'promotion',
        component: function () {
          return import('../views/marketing/activity/couponView.vue')
        },
        meta: { title: '促销活动' }
      },
      {
        path: '/promotion_goods',
        name: 'promotion_goods',
        component: function () {
          return import('../views/marketing/activity/activity_goods.vue')
        },
        meta: { title: '设置活动商品' }
      },
      {
        path: '/pickup_list',
        name: 'pickup_list',
        component: function () {
          return import('../views/marketing/gift/pickup.vue')
        },
        meta: { title: '礼品卡活动' }
      },
      {
        path: '/pickup_list_data',
        name: 'pickup_list_data',
        component: function () {
          return import('../views/marketing/gift/gift_data.vue')
        },
        meta: { title: '礼品卡数据' }
      },
      {
        path: '/pickup_list_set_goods',
        name: 'pickup_list_set_goods',
        component: function () {
          return import('../views/marketing/gift/goodsList.vue')
        },
        meta: { title: '设置活动商品' }
      },
      {
        path: '/promotion_audit',
        name: 'promotion_audit',
        component: function () {
          return import('../views/marketing/aduit/promotionAudit.vue')
        },
        meta: { title: '活动审核列表' }
      },
      {
        path: '/promotion_insert_activity',
        name: 'promotion_insert_activity',
        component: function () {
          return import('../views/marketing/activity/insertActivity.vue')
        },
        meta: { title: '新增活动' }
      },
      {
        path: '/insert_pickup_list',
        name: 'insert_pickup_list',
        component: function () {
          return import('../views/marketing/gift/insertGift.vue')
        },
        meta: { title: '新增礼品卡活动' }
      },
      {
        path: '/coupon',
        name: 'coupon',
        component: function () {
          return import('../views/marketing/activity/promotionView.vue')
        },
        meta: { title: '优惠券' }
      },
      {
        path: '/coupon_data',
        name: 'coupon_data',
        component: function () {
          return import('../views/marketing/activity/couponData.vue')
        },
        meta: { title: '优惠券数据' }
      },
      {
        path: '/card_coupon',
        name: 'card_coupon',
        component: function () {
          return import('../views/marketing/activity/card_coupon.vue')
        },
        meta: { title: '会员卡优惠券' }
      },
      {
        path: '/hot_words',
        name: 'hot_words',
        component: function () {
          return import('../views/marketing/set/hotWords.vue')
        },
        meta: { title: '热词管理' }
      },
      {
        path: '/insert_coupon',
        name: 'insert_coupon',
        component: function () {
          return import('../views/marketing/activity/insertCoupon.vue')
        },
        meta: { title: '新增优惠券' }
      },
      {
        path: '/points_cate',
        name: 'points_cate',
        component: function () {
          return import('../views/goods/points/pointsCate.vue')
        },
        meta: { title: '海金商品分类' }
      },
      {
        path: '/points_product',
        name: 'points_product',
        component: function () {
          return import('../views/goods/points/pointsProduct.vue')
        },
        meta: { title: '海金商品列表',keepAlive: true }
      },
      {
        path: '/audit_point_product',
        name: 'audit_point_product',
        component: function () {
          return import('../views/goods/examine/auditPointProduct.vue')
        },
        meta: { title: '海金商品审核列表' }
      },
      {
        path: '/cash_order',
        name: 'cash_order',
        component: function () {
          return import('../views/order/goods/cash_order.vue')
        },
        meta: { title: '普通订单' }
      },
      {
        path: '/abn_order',
        name: 'abn_order',
        component: function () {
          return import('../views/order/abnormal/abn_order.vue')
        },
        meta: { title: '异常订单' }
      },
      {
        path: '/exp_order',
        name: 'exp_order',
        component: function () {
          return import('../views/order/goods/exp_order.vue')
        },
        meta: { title: '订单列表' }
      },
      {
        path: '/point_order',
        name: 'point_order',
        component: function () {
          return import('../views/order/goods/point_order.vue')
        },
        meta: { title: '订单列表' }
      },
      {
        path: '/cash_order_detail',
        name: 'cash_order_detail',
        component: function () {
          return import('../views/order/detail/order_detail.vue')
        },
        meta: { title: '订单详情' }
      },
      {
        path: '/vip_order',
        name: 'vip_order',
        component: function () {
          return import('../views/order/member/vip_order.vue')
        },
        meta: { title: '会员卡订单' }
      },
      {
        path: '/pickup_card_order',
        name: 'pickup_card_order',
        component: function () {
          return import('../views/order/goods/pickup_order.vue')
        },
        meta: { title: '礼品卡订单' }
      },
      {
        path: '/recharge_order',
        name: 'recharge_order',
        component: function () {
          return import('../views/order/member/recharge_order.vue')
        },
        meta: { title: '充值订单' }
      },
      {
        path: '/erp_order',
        name: 'erp_order',
        component: function () {
          return import('../views/order/erp/erp_order.vue')
        },
        meta: { title: 'erp线下订单' }
      },
      {
        path: '/after_sale_cancel_order',
        name: 'after_sale_cancel_order',
        component: function () {
          return import('../views/order/afterSales/after_sale_cancel_order.vue')
        },
        meta: { title: '取消订单' }
      },
      {
        path: '/after_sale_order',
        name: 'after_sale_order',
        component: function () {
          return import('../views/order/afterSales/after_sale_order.vue')
        },
        meta: { title: '售后订单' }
      },
      {
        path: '/after_sale_order_detail',
        name: 'after_sale_order_detail',
        component: function () {
          return import('../views/order/detail/after_detail.vue')
        },
        meta: { title: '售后详情' }
      },
      {
        path: '/staff_distrib',
        name: 'staff_distrib',
        component: function () {
          return import('../views/distribution/staff/merchant_staff_distrib.vue')
        },
        meta: { title: '员工分销列表' }
      },
      {
        path: '/user_distrib',
        name: 'user_distrib',
        component: function () {
          return import('../views/distribution/member/user_distrib.vue')
        },
        meta: { title: '会员分销列表' }
      },
      {
        path: '/user_distrib_set',
        name: 'user_distrib_set',
        component: function () {
          return import('../views/distribution/member/user_distrib_set.vue')
        },
        meta: { title: '会员分销设置' }
      },
      {
        path: '/staff_distrib_set',
        name: 'staff_distrib_set',
        component: function () {
          return import('../views/distribution/staff/merchant_staff_distrib_set.vue')
        },
        meta: { title: '员工分销设置' }
      },
      {
        path: '/user_distrib_details',
        name: 'user_distrib_details',
        component: function () {
          return import('../views/distribution/details/details.vue')
        },
        meta: { title: '分销明细' }
      },
      {
        path: '/delivery_template',
        name: 'delivery_template',
        component: function () {
          return import('../views/logistics/logistics/delivery_template.vue')
        },
        meta: { title: '配送模板' }
      },
      {
        path: '/delivery_template_insertView',
        name: 'delivery_template_insertView',
        component: function () {
          return import('../views/logistics/logistics/insertView.vue')
        },
        meta: { title: '新增模板' }
      },
      {
        path: '/shipping_template',
        name: 'shipping_template',
        component: function () {
          return import('../views/logistics/logistics/shipping.vue')
        },
        meta: { title: '运费模板' }
      },
      {
        path: '/o2o_delivery',
        name: 'o2o_delivery',
        component: function () {
          return import('../views/logistics/o2o/o2o_delivery.vue')
        },
        meta: { title: '同城配送' }
      },
      {
        path: '/shipping_template_insertShopping',
        name: 'shipping_template_insertShopping',
        component: function () {
          return import('../views/logistics/logistics/insertShipping.vue')
        },
        meta: { title: '新增运费模板' }
      },{
        path: '/message_config',
        name: 'message_config',
        component: function () {
          return import('../views/message/notice/merchant_message_config.vue')
        },
        meta: { title: '消息管理' }
      },
      {
        path: '/message_center',
        name: 'message_center',
        component: function () {
          return import('../views/message/center/list.vue')
        },
        meta: { title: '消息中心' }
      },
      {
        path: '/message_record',
        name: 'message_record',
        component: function () {
          return import('../views/message/center/list.vue')
        },
        meta: { title: '消息中心' }
      },
      {
        path: '/mini_config',
        name: 'mini_config',
        component: function () {
          return import('../views/merchant/merchant_mini_config.vue')
        },
        meta: { title: '小程序设置' }
      },
      {
        path: '/analysis_cash_order',
        name: 'analysis_cash_order',
        component: function () {
          return import('../views/data_analysis/order/analysis_cash_order.vue')
        },
        meta: { title: '普通订单数据分析' }
      },
      {
        path: '/analysis_explosive_order',
        name: 'analysis_explosive_order',
        component: function () {
          return import('../views/data_analysis/order/analysis_explosive_order.vue')
        },
        meta: { title: '订单数据分析' }
      },
      {
        path: '/analysis_point_order',
        name: 'analysis_point_order',
        component: function () {
          return import('../views/data_analysis/order/analysis_point_order.vue')
        },
        meta: { title: '订单数据分析' }
      },
      {
        path: '/analysis_cash_product',
        name: 'analysis_cash_product',
        component: function () {
          return import('../views/data_analysis/goods/analysis_cash_product.vue')
        },
        meta: { title: '普通商品数据' }
      },{
        path: '/analysis_explosive_product',
        name: 'analysis_explosive_product',
        component: function () {
          return import('../views/data_analysis/goods/analysis_explosive_product.vue')
        },
        meta: { title: '商品数据' }
      },
      {
        path: '/analysis_point_product',
        name: 'analysis_point_product',
        component: function () {
          return import('../views/data_analysis/goods/analysis_point_product.vue')
        },
        meta: { title: '商品数据' }
      },
      {
        path: '/analysis_distribution_data',
        name: 'analysis_distribution_data',
        component: function () {
          return import('../views/data_analysis/distribution/analysis_distribution_data.vue')
        },
        meta: { title: '员工分销数据' }
      },
      {
        path: '/analysis_distribution_user_data',
        name: 'analysis_distribution_user_data',
        component: function () {
          return import('../views/data_analysis/distribution/analysis_distribution_user_data.vue')
        },
        meta: { title: '会员分销数据' }
      },
      {
        path: '/analysis_explosive_data',
        name: 'analysis_explosive_data',
        component: function () {
          return import('../views/data_analysis/shopping_gold/analysis_explosive_data.vue')
        },
        meta: { title: '数据' }
      },
      {
        path: '/analysis_point_data',
        name: 'analysis_point_data',
        component: function () {
          return import('../views/data_analysis/shopping_gold/analysis_point_data.vue')
        },
        meta: { title: '海金数据' }
      },
      {
        path: '/analysis_user_card_data',
        name: 'analysis_user_card_data',
        component: function () {
          return import('../views/data_analysis/member/analysis_user_card_data.vue')
        },
        meta: { title: '办卡数据' }
      },
      {
        path: '/analysis_user_consume_data',
        name: 'analysis_user_consume_data',
        component: function () {
          return import('../views/data_analysis/member/analysis_user_consume_data.vue')
        },
        meta: { title: 'VIP消费数据' }
      },
      {
        path: '/analysis_user_data',
        name: 'analysis_user_data',
        component: function () {
          return import('../views/data_analysis/member/analysis_user_data.vue')
        },
        meta: { title: '会员数据' }
      },
      {
        path: '/financial_cash',
        name: 'financial_cash',
        component: function () {
          return import('../views/finance/account/financial_cash.vue')
        },
        meta: { title: '现金账户' }
      },
      {
        path: '/financial_explosive',
        name: 'financial_explosive',
        component: function () {
          return import('../views/finance/account/financial_explosive.vue')
        },
        meta: { title: '海斛账户' }
      },
      {
        path: '/financial_o2o',
        name: 'financial_o2o',
        component: function () {
          return import('../views/finance/bill/financial_o2o.vue')
        },
        meta: { title: 'o2o配送账户' }
      },
      {
        path: '/financial_o2o_detail',
        name: 'financial_o2o_detail',
        component: function () {
          return import('../views/finance/bill/detail_o2o.vue')
        },
        meta: { title: 'o2o配送账户' }
      },
      {
        path: '/order_prescription_list',
        name: 'order_prescription_list',
        component: function () {
          return import('../views/prescription/order_prescription_list.vue')
        },
        meta: { title: '处方列表' }
      },
      {
        path: '/order_prescription_process',
        name: 'order_prescription_process',
        component: function () {
          return import('../views/prescription/order_prescription_process.vue')
        },
        meta: { title: '处方审核列表' }
      },
      {
        path: '/explosive_info',
        name: 'explosive_info',
        component: function () {
          return import('../views/shopping_gold/merchant_explosive_info.vue')
        },
        meta: { title: '商户' }
      },
      {
        path: '/explosive_info_recharge',
        name: 'explosive_info_recharge',
        component: function () {
          return import('../views/shopping_gold/recharge.vue')
        },
        meta: { title: '充值' }
      },
      {
        path: '/user_explosive_info',
        name: 'user_explosive_info',
        component: function () {
          return import('../views/shopping_gold/user_explosive_info.vue')
        },
        meta: { title: '会员' }
      },
      {
        path: '/user_explosive_info_detail',
        name: 'user_explosive_info_detail',
        component: function () {
          return import('../views/shopping_gold/detail.vue')
        },
        meta: { title: '明细' }
      },
      {
        path: '/user_point_info',
        name: 'user_point_info',
        component: function () {
          return import('../views/shopping_gold/user_point_info.vue')
        },
        meta: { title: '海金' }
      },
      {
        path: '/o2o_auto_set',
        name: 'o2o_auto_set',
        component: function () {
          return import('../views/logistics/o2o/o2o_auto_set.vue')
        },
        meta: { title: '配送设置' }
      },
      {
        path: '/overview',
        name: 'overview',
        component: function () {
          return import('../views/overview/overview.vue')
        },
        meta: { title: '数据概览' }
      },
      {
        path: '/finanrider',
        name: 'finanrider',
        component: function () {
          return import('../views/finance/logistics/finanrider.vue')
        },
        meta: { title: '配送账户' }
      },
      {
        path: '/finanrider_detail',
        name: 'finanrider_detail',
        component: function () {
          return import('../views/finance/logistics/detail.vue')
        },
        meta: { title: '订单明细' }
      },
      {
        path: '/finanexpress',
        name: 'finanexpress',
        component: function () {
          return import('../views/finance/logistics/finanexpress.vue')
        },
        meta: { title: '快递账户' }
      },
      {
        path: '/finanexpress_detail',
        name: 'finanexpress_detail',
        component: function () {
          return import('../views/finance/logistics/expressdetail.vue')
        },
        meta: { title: '订单明细' }
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    // 设置标题
    document.title = to.meta.title;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token_merchant')) {
      router.push({ path: "/", replace: true });
    }
    next();
  }else{
    next();
  }
});

export default router
